import formName from 'constants/formName'
import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'

import account from './Account/slice'
import app from './App/reducers'
import auth from './Auth/reducers'
import balance from './Balance/reducers'
import config from './Config/slice'
import currencies from './Currencies/reducers'
import eligibility from './Eligibility/slice'
import ticketForm from './Form/Ticket/reducers'
import withdrawal from './Form/Withdrawal/reducers'
import historical from './Historical/reducers'
import instrument from './Instrument/reducers'
import margin from './Margin/slice'
import order from './Order/reducers'
import payments from './Payments/reducers'
import price from './Price/reducers'
import referral from './Referral/slice'
import accountSettings from './Settings/Account/slice'
import socket from './Socket/reducers'
import ticker from './Ticker/reducers'
import trades from './Trades/reducers'

const form = formReducer.plugin({
  [formName.TICKET]: ticketForm
})

const reducers = {
  account,
  accountSettings,
  app,
  auth,
  balance,
  config,
  currencies,
  eligibility,
  form,
  historical,
  instrument,
  margin,
  order,
  payments,
  price,
  referral,
  socket,
  ticker,
  trades,
  withdrawal
}
const combined = combineReducers<typeof reducers>(reducers)

export default combined
